
const navigation = {
  home: 'ホーム',
  sugar: '砂糖',
  coffee: 'コーヒー',
  logistics: '物流',
  news: 'ニュース',
  contact: 'お問い合わせ'
};

const hero = {
  title: '商品輸出',
  subtitle: 'ブラジルから世界へ：砂糖とコーヒー',
  description: 'ブラジルは砂糖とコーヒーの生産・輸出において世界のリーダーです。このサイトでは、これらの製品、市場、輸出物流などについて包括的に紹介しています。',
  exploreSugar: '砂糖を探る',
  discoverCoffee: 'コーヒーを発見'
};

const features = {
  title: 'セクションを探る',
  description: 'ブラジルの主要商品のプロセス、市場、物流について詳細な情報を発見',
  sugar: {
    title: '砂糖輸出プロセスを学ぶ',
    description: '畑から港まで：ブラジルの砂糖が国際市場に到達する過程を理解'
  },
  coffee: {
    title: 'ブラジルコーヒーの道のりを発見',
    description: 'ブラジルを世界最大のコーヒー輸出国にする伝統と品質'
  },
  logistics: {
    title: '物流と貨物船を理解',
    description: '輸出を可能にする港湾・輸送インフラ'
  },
  learnMore: '詳細を学ぶ'
};

const stats = {
  title: 'ブラジルの数字',
  description: '世界の商品市場におけるブラジルの重要性を示すデータ',
  sugarExport: '生産された砂糖が輸出される',
  coffeeWorld: '世界のコーヒーがブラジル産',
  mainPorts: '主要輸出港',
  countries: '仕向国'
};

const cta = {
  title: '最新情報を保つ',
  description: '商品市場の最新トレンドと業界ニュースをフォロー',
  seeNews: 'ニュースを見る',
  contact: 'お問い合わせ'
};

// Sugar page translations
const sugar = {
  hero: {
    title: 'ブラジルの砂糖',
    subtitle: '畑から港まで'
  },
  types: {
    title: '輸出砂糖の種類',
    vhp: {
      name: 'VHP（極高偏光糖）',
      description: '高偏光の粗糖、精製に最適'
    },
    refined: {
      name: '精製糖',
      description: '白色精製糖、消費準備完了'
    },
    crystal: {
      name: 'クリスタル',
      description: '結晶糖、国内市場でより一般的'
    }
  },
  regions: {
    title: '主要生産地域',
    sp: {
      name: 'サンパウロ州',
      production: '55%',
      description: '国内最大の生産地域'
    },
    mg: {
      name: 'ミナスジェライス州',
      production: '12%',
      description: '第2位の生産地域'
    },
    go: {
      name: 'ゴイアス州',
      production: '10%',
      description: '中西部の重要地域'
    }
  },
  process: {
    title: '輸出プロセス',
    step1: {
      title: 'サトウキビ収穫',
      description: '機械化または手作業でのサトウキビ収穫'
    },
    step2: {
      title: '製糖工場での処理',
      description: 'サトウキビの粉砕と搾汁'
    },
    step3: {
      title: '貯蔵と輸送',
      description: 'サイロでの貯蔵と道路輸送'
    },
    step4: {
      title: '港での積み込み',
      description: 'バルクキャリアへの積み込み'
    }
  },
  market: {
    title: '国際市場',
    destinations: '主要仕向地',
    factors: {
      title: '価格に影響する要因',
      climate: {
        title: '気候条件：',
        description: '干ばつや過度の降雨が生産に影響'
      },
      oil: {
        title: '石油価格：',
        description: '代替としてのエタノール生産に影響'
      },
      demand: {
        title: '世界需要：',
        description: '人口増加と消費の変化'
      },
      exchange: {
        title: '為替レート：',
        description: 'ドルの変動が競争力に影響'
      }
    }
  },
  curiosities: {
    title: 'ブラジル砂糖の興味深い事実',
    exported: 'ブラジルの生産量が輸出される',
    worldShare: '世界の砂糖がブラジル産',
    mills: '国内で稼働中の製糖工場',
    hectares: 'サトウキビ植栽面積（ヘクタール）',
    worldRank: '世界生産順位',
    countries: 'わが国の砂糖を輸入する国'
  }
};

// Coffee page translations
const coffee = {
  hero: {
    title: 'ブラジルのコーヒー',
    subtitle: '伝統と世界品質'
  },
  history: {
    title: '歴史と経済的重要性',
    worldProduction: '世界生産',
    jobs: '創出雇用',
    exports: '年間輸出',
    importers: '輸入国'
  },
  types: {
    title: '輸出コーヒーの種類',
    arabica: {
      name: 'アラビカ',
      percentage: '75%',
      description: '高品質コーヒー、まろやかで芳香豊か',
      regions: 'ミナスジェライス、サンパウロ、エスピリトサント'
    },
    robusta: {
      name: 'ロブスタ（コニロン）',
      percentage: '25%',
      description: 'より耐性のあるコーヒー、強い味とより高いカフェイン含有量',
      regions: 'エスピリトサント、ロンドニア、バイア'
    }
  },
  states: {
    title: '生産州',
    mg: {
      name: 'ミナスジェライス',
      production: '54%',
      specialty: '山岳アラビカ'
    },
    es: {
      name: 'エスピリトサント',
      production: '23%',
      specialty: 'コニロンとアラビカ'
    },
    sp: {
      name: 'サンパウロ',
      production: '9%',
      specialty: '伝統的アラビカ'
    },
    ba: {
      name: 'バイア',
      production: '8%',
      specialty: 'コニロンとスペシャルティコーヒー'
    }
  },
  process: {
    title: '輸出プロセス',
    step1: {
      title: '収穫',
      description: '手作業（デリッサ）または機械'
    },
    step2: {
      title: '乾燥',
      description: 'テラスでの自然乾燥または人工乾燥'
    },
    step3: {
      title: '精製',
      description: '脱殻と分級'
    },
    step4: {
      title: '貯蔵',
      description: '袋詰めまたはコンテナ'
    },
    step5: {
      title: '輸出',
      description: '港での船積み'
    }
  },
  market: {
    title: '仕向地と世界消費',
    destinations: '主要仕向地',
    factors: {
      title: '市場要因',
      quotes: {
        title: '国際相場：',
        description: 'ニューヨークとロンドンの取引所が価格を決定'
      },
      climate: {
        title: '気候条件：',
        description: '霜害と干ばつが価格に大きく影響'
      },
      quality: {
        title: '品質：',
        description: 'スペシャルティコーヒーはプレミアム価格を達成'
      },
      logistics: {
        title: '物流：',
        description: '輸送コストが競争力に影響'
      }
    }
  },
  trends: {
    title: '市場トレンド',
    specialty: {
      title: 'スペシャルティコーヒー',
      description: 'シングルオリジンコーヒーと特別な抽出方法への需要拡大'
    },
    certifications: {
      title: '認証',
      description: 'オーガニック、フェアトレード、レインフォレストアライアンス認証'
    },
    sustainability: {
      title: '持続可能性',
      description: '環境に責任を持ち、社会的に公正な実践'
    }
  }
};

// Logistics page translations
const logistics = {
  hero: {
    title: '物流と輸送',
    subtitle: '輸出を支えるインフラ'
  },
  ships: {
    title: '貨物船の種類',
    bulk: {
      name: 'バルクキャリア',
      description: '砂糖などのバルク製品の輸送専用船',
      capacity: '6万〜20万トン'
    },
    containers: {
      name: 'ドライコンテナ',
      description: '袋詰めコーヒーと包装製品の輸送',
      capacity: '1,000〜20,000TEU'
    },
    refrigerated: {
      name: '冷凍コンテナ',
      description: '温度管理が必要な製品用',
      capacity: '200〜2,000TEU'
    }
  },
  ports: {
    title: '主要輸出港',
    santos: {
      name: 'サントス港（SP）',
      description: 'ラテンアメリカ最大の港',
      products: '砂糖、コーヒー、大豆',
      capacity: '年間480万TEU'
    },
    paranagua: {
      name: 'パラナグア港（PR）',
      description: '南部の主要輸出回廊',
      products: '砂糖、大豆、トウモロコシ',
      capacity: '年間120万TEU'
    },
    vitoria: {
      name: 'ビトリア港（ES）',
      description: '鉱石とコーヒーに重要',
      products: 'コーヒー、砂糖、鉱石',
      capacity: '年間80万TEU'
    },
    itaqui: {
      name: 'イタキ港（MA）',
      description: '北東部のゲートウェイ',
      products: '砂糖、大豆、トウモロコシ',
      capacity: '年間60万TEU'
    }
  },
  storage: {
    title: '倉庫と貯蔵',
    silos: {
      name: 'バルクサイロ',
      description: 'バルク砂糖の垂直貯蔵',
      capacity: '1万〜10万トン'
    },
    warehouses: {
      name: '保税倉庫',
      description: '輸出待ち製品の倉庫',
      capacity: '5,000〜5万トン'
    },
    refrigerated: {
      name: '冷蔵倉庫',
      description: '温度に敏感な製品の保存',
      capacity: '1,000〜2万トン'
    }
  },
  transport: {
    title: '国内輸送',
    modes: '輸送モード',
    road: {
      name: '道路',
      percentage: '70%',
      description: '国内輸送の主要モード'
    },
    rail: {
      name: '鉄道',
      percentage: '25%',
      description: '一部地域で使用拡大'
    },
    waterway: {
      name: '水路',
      percentage: '5%',
      description: '特定地域で使用'
    },
    characteristics: {
      title: '輸送特性',
      distances: {
        title: '平均距離',
        farm: '農場→倉庫：50-200km',
        warehouse: '倉庫→港：200-800km',
        time: '平均時間：2-5日'
      },
      costs: {
        title: '物流コスト',
        percent: '最終価格の15-25%を占める',
        fuel: '燃料：最大構成要素',
        tolls: '通行料と港湾料金'
      },
      seasonality: {
        title: '季節性',
        peak: '収穫期のピーク（5-9月）',
        demand: 'より大きな輸送需要',
        increase: '運賃の上昇'
      }
    }
  },
  challenges: {
    title: '課題と機会',
    infrastructure: {
      title: '港湾インフラ',
      description: '近代化と容量拡張の必要性'
    },
    costs: {
      title: '物流コスト',
      description: '輸送・貯蔵コストの削減'
    },
    sustainability: {
      title: '持続可能性',
      description: '環境に責任ある実践の実装'
    },
    digitalization: {
      title: 'デジタル化',
      description: 'プロセスの自動化とデジタル制御'
    }
  },
  numbers: {
    title: '物流の数字',
    tonnage: '年間取扱トン数',
    ports: '組織化された港',
    terminals: '民間ターミナル',
    gdp: 'GDPの物流コスト'
  }
};

// News page translations
const news = {
  hero: {
    title: 'ニュースとトレンド',
    subtitle: '輸出市場で何が起こっているか？'
  },
  market: {
    title: 'リアルタイム相場'
  },
  tabs: {
    recent: '最新ニュース',
    analysis: '分析',
    forecasts: '予測'
  },
  analysis: {
    title: '市場分析',
    positive: {
      title: 'ポジティブ要因',
      climate: '次回収穫に有利な気候',
      demand: '国際需要の拡大',
      infrastructure: '物流インフラの改善'
    },
    challenges: {
      title: '課題',
      exchange: '為替レートの変動',
      competition: '国際競争',
      costs: '高い物流コスト'
    }
  },
  newsletter: {
    title: '情報を保つ',
    description: '商品市場の週次アップデートを直接メールで受け取る',
    placeholder: 'あなたのメール',
    subscribe: '購読'
  }
};

// Contact page translations
const contact = {
  hero: {
    title: 'プロジェクトについて',
    subtitle: 'チームを知り、お問い合わせください'
  },
  about: {
    title: '私たちについて'
  },
  objectives: {
    title: '私たちの目標',
    educational: {
      title: '教育的',
      description: 'ブラジルの主要商品の生産と輸出プロセスについて教育'
    },
    informative: {
      title: '情報提供',
      description: '市場、価格、セクターのトレンドに関する最新データを提供'
    },
    connective: {
      title: '接続',
      description: 'ブラジルのアグリビジネスに興味を持つ様々な層を接続'
    }
  },
  team: {
    title: '私たちのチーム'
  },
  sources: {
    title: 'データソース',
    description: '提供する情報の正確性と信頼性を保証するため、認定機関の公式データのみを使用しています。'
  },
  form: {
    title: 'お問い合わせ',
    subtitle: '質問、提案、または貢献をお考えですか？お話しください！',
    name: 'フルネーム',
    email: 'メール',
    subject: '件名',
    message: 'メッセージ',
    send: 'メッセージを送信',
    sending: '送信中...',
    success: 'メッセージが正常に送信されました！すぐにご連絡いたします。',
    error: 'メッセージ送信エラー。再試行してください。',
    selectSubject: '件名を選択',
    subjects: {
      doubt: 'データに関する質問',
      suggestion: '改善提案',
      contribution: 'データ貢献',
      partnership: 'パートナーシップ提案',
      press: '報道',
      other: 'その他'
    },
    placeholder: {
      name: 'あなたのフルネーム',
      email: 'あなたの@メール.com',
      message: 'メッセージを記述してください（最大500文字）'
    },
    charRemaining: '残り文字数'
  },
  social: {
    title: 'フォローしてください',
    description: 'ソーシャルメディアで私たちをフォローして、商品市場の最新アップデートを受け取ってください'
  }
};

export default {
  navigation,
  hero,
  features,
  stats,
  cta,
  sugar,
  coffee,
  logistics,
  news,
  contact
};
